import * as S from './styles';

export type TextAlign = 'center' | 'left';

interface Props {
  textAlign?: TextAlign;
  noMargin?: boolean;
}

const TextWrapper: React.FC<React.PropsWithChildren<Props>> = ({
  textAlign,
  noMargin,
  children,
}) => (
  <S.TextWrapper textAlign={textAlign} noMargin={noMargin}>
    {children}
  </S.TextWrapper>
);

export default TextWrapper;
